


















import { Component, Prop, Vue } from 'vue-property-decorator';
import FilterIcon from '@/components/Icons/FilterIcon/index.vue';

@Component({
  components: {
    FilterIcon,
  },
})
export default class ToolTipIcon extends Vue {
}
